import React, { useEffect, useState } from 'react';
import animationData from "../assets/contactpage.json";
import Lottie from "lottie-react";
import axios from 'axios';
import MapComponent from './MapComponent';
import SEO from '../components/SEO';

const Contact = () => {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [successMsg, setSuccessMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "message") {
      setCharCount(value.length);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");

    const { name, email, phone, subject, message } = formData;

    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        name,
        email,
        phone,
        subject,
        message,
      });

      setSuccessMsg("✅ Message sent successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
      setCharCount(0);
    } catch (err) {
      console.error("❌ Failed to send message:", err);
      alert("❌ Failed to send message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div >
      <SEO
        title="Contact Us | Lavanya Infotech"
        description="Get in touch with Lavanya Infotech for your IT, web development, branding, and digital transformation needs. We're here to help you innovate."
      />

      <h1 className="title font-poppins text-4xl sm:text-5xl xl:pt-10 text-center font-bold">
        Contact Us
        <div className="aurora text-3xl">
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
        </div>
      </h1>

      <div className="text-slider pt-2 mt-10 text-center mb-10">
        <div className="animated-texts">
          <span className="animated-item text-blue-300 border-b-4 border-blue-300 text-2xl sm:text-3xl font-semibold">Collaborate</span>
          <span className="animated-item text-green-300 border-b-4 border-green-300 text-2xl sm:text-3xl font-semibold">Connect 24/7</span>
          <span className="animated-item text-purple-300 border-b-4 border-purple-300 text-2xl sm:text-3xl font-semibold">Support</span>
          <span className="animated-item text-yellow-300 border-b-4 border-yellow-300 text-2xl sm:text-3xl font-semibold">Engage</span>
        </div>
      </div>


      <div className="bg-black xyz1 text-white py-12 px-4 sm:px-8 md:px-12 lg:px-20">

        <div className="flex flex-col-reverse lg:flex-row items-start gap-10">


          {/* Contact Form */}
          <form className="w-full lg:w-1/2 space-y-6" onSubmit={handleSubmit}>
            {[
              { label: "Your Name", name: "name", type: "text", required: true },
              { label: "Email Address", name: "email", type: "email", required: true },
              { label: "Phone Number", name: "phone", type: "tel" },
              { label: "Subject", name: "subject", type: "text" }
            ].map(({ label, name, type, required }) => (
              <div key={name}>
                <label className="block mb-1 text-sm">{label}{required && " *"}</label>
                <input
                  type={type}
                  name={name}
                  required={required}
                  value={formData[name]}
                  onChange={handleChange}
                  className="w-full bg-transparent border-b border-gray-400 py-1 outline-none"
                />
              </div>
            ))}

            {/* Message */}
            <div>
              <label className="block mb-1 text-sm">Message</label>
              <textarea
                name="message"
                rows="4"
                maxLength={180}
                value={formData.message}
                onChange={handleChange}
                className="w-full bg-transparent border border-gray-400 p-2"
              ></textarea>
              <div className="text-right text-sm text-gray-400">{charCount} / 180</div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className={`bg-sky-500 hover:bg-sky-600 text-white px-6 py-2 rounded transition ${loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
            >
              {loading ? "Sending..." : "Send Message"}
            </button>

            {/* Success Message */}
            {successMsg && <p className="text-green-400 mt-3">{successMsg}</p>}
          </form>

          {/* Lottie Animation */}
          <div className="w-full lg:w-1/2 flex flex-col items-center justify-center space-y-6">
            <Lottie
              animationData={animationData}
              loop
              autoplay
              className="w-[250px] sm:w-[300px] md:w-[400px] lg:w-[550px] h-auto"
            />
          </div>
        </div>
      </div>

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center gap-6 p-6 bg-black text-white">
        {/* Address Card */}
        <div className="flex items-center gap-4 bg-sky-600 px-6 py-4 rounded-xl w-80">
          <div className="bg-white p-3 rounded-full">
            <img src="https://img.icons8.com/ios-filled/50/1E88E5/marker.png" alt="location" width="32" />
          </div>
          <p>
            75, First Floor Meera Nagar Soc., Ak Road, Mini Bazar, Varachha, Surat. Pincode-395006
          </p>
        </div>

        {/* Email Card */}
        <div className="flex items-center gap-4 bg-red-600 px-6 py-4 rounded-xl w-80">
          <div className="bg-white p-3 rounded-full">
            <img src="https://img.icons8.com/ios-filled/50/C62828/email.png" alt="email" width="32" />
          </div>
          <p> infotech.lavanya.18@gmail.com</p>
        </div>

        {/* Phone Card */}
        <div className="flex items-center gap-4 bg-green-500 px-6 py-4 rounded-xl w-80">
          <div className="bg-whie p-3 rounded-full">
            <img src="https://img.icons8.com/ios-filled/50/2E7D32/phone.png" alt="phone" width="32" />
          </div>
          <p>+91 87585 76361</p>
        </div>
      </div>

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>

      <MapComponent />

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>

    </div>
  );
};

export default Contact;
